"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Refresh;

var _Refresh = require("@adobe/react-spectrum-workflow/dist/Refresh");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Refresh(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Refresh.A4uRefresh, null));
}